import React from 'react';
import Aux from '../../hoc/Aux';
import { useTranslation } from 'react-i18next';

const productSystemTableRowRohr = (props) => {

  const { t } = useTranslation();

  const colFwk = props.colFwk;
  const colLayer = props.colLayer;
  const colAnzahl = props.colAnzahl;
  const fromToValue = props.fromToValue;
  const fromToValueUnendlich = props.fromToValueUnendlich;
  const isSelected = props.isSelected;
  const globalGap = props.globalGap;

  // Ausgabe der Isolierung. Die Isolierung kann aus zwei Teilen bestehen.
  // Es gibt die "Vorhandene Isolierung" und die Isolierung aus "Abschottung mit ..."
  const insulationNames = () => {
    if (checkIfInsulationIsEmpty(props.item.insulation_id) && checkIfInsulationIsEmpty(props.item.sealinsulation_id)) {
      return ""
    } else {
      if (checkIfInsulationIsEmpty(props.item.sealinsulation_id) && !checkIfInsulationIsEmpty(props.item.insulation_id)) {
        return t(props.item.insulation)
      } else if (!checkIfInsulationIsEmpty(props.item.sealinsulation_id) && checkIfInsulationIsEmpty(props.item.insulation_id )) {
        return t(props.item.sealinsulation)
      } else {
        return (
          <Aux>
            <span>{t(props.item.insulation)}</span>
            <hr style={{margin: "0px", borderStyle: "dashed"}} />
            <span>{t(props.item.sealinsulation)}</span>
          </Aux>
        )
      }
    }
  }

  const insulationThickness = () => {
    if (checkIfInsulationIsEmpty(props.item.insulation_id) && checkIfInsulationIsEmpty(props.item.sealinsulation_id)) {
      return ""
    } else {
      if (checkIfInsulationIsEmpty(props.item.sealinsulation_id) && !checkIfInsulationIsEmpty(props.item.insulation_id)) {
        return insulationThicknessUnendlich()
      } else if (!checkIfInsulationIsEmpty(props.item.sealinsulation_id) && checkIfInsulationIsEmpty(props.item.insulation_id )) {
        return sealinsulationThicknessUnendlich()
      } else {
        return (
          <Aux>
            <span>{insulationThicknessUnendlich()}</span>
            <hr style={{margin: "0px", borderStyle: "dashed"}} />
            <span>{sealinsulationThicknessUnendlich()}</span>
          </Aux>
        )
      }
    }
  }

  const insulationLength = () => {
    if (checkIfInsulationIsEmpty(props.item.insulation_id) && checkIfInsulationIsEmpty(props.item.sealinsulation_id)) {
      return ""
    } else {
      if (checkIfInsulationIsEmpty(props.item.sealinsulation_id) && !checkIfInsulationIsEmpty(props.item.insulation_id)) {
        return props.item.insulation_configuration_decoration_main
      } else if (!checkIfInsulationIsEmpty(props.item.sealinsulation_id) && checkIfInsulationIsEmpty(props.item.insulation_id )) {
        return props.item.insulation_configuration_decoration_seal
      } else {
        return (
          <Aux>
            <span>{props.item.insulation_configuration_decoration_main}</span>
            <hr style={{margin: "0px", borderStyle: "dashed"}} />
            <span>{props.item.insulation_configuration_decoration_seal}</span>
          </Aux>
        )
      }
    }
  }






  const insulationThicknessUnendlich = () => {
    if ((props.item.insulation_strength_min == null || props.item.insulation_strength_min == "" || props.item.insulation_strength_min == undefined) &&
    (props.item.insulation_strength_max == null || props.item.insulation_strength_max == "" || props.item.insulation_strength_max == undefined)) {
      return "-"
    } else {
      return fromToValueUnendlich(props.item.insulation_strength_min, props.item.insulation_strength_max)
    }
  }

  const sealinsulationThicknessUnendlich = () => {
    if ((props.item.sealinsulation_strength_min == null || props.item.sealinsulation_strength_min == "" || props.item.sealinsulation_strength_min == undefined) &&
    (props.item.sealinsulation_strength_max == null || props.item.sealinsulation_strength_max == "" || props.item.sealinsulation_strength_max == undefined)) {
      return "-"
    } else {
      return fromToValueUnendlich(props.item.sealinsulation_strength_min, props.item.sealinsulation_strength_max)
    }
  }

  const checkIfInsulationIsEmpty = (insulation) => {
    if (insulation !== null && insulation !== "" && insulation !== undefined && insulation !== []) {
      return false
    } else {
      return true
    }
  }

  const products_col = (item) => {
    if (item.products !== null && item.products !== "" && item.products !== []) {
      return item.products.map((product, index) => { 
        if (product.producttype === "woven") {
          return product.title + " (" + product.woven_amount + "x " + product.woven_layer + ")"
        } else if (product.producttype === "thing") {
          return product.title + " (" + product.thing_amount + ")"
        } else {
          return product.title
        } 
      }).join(", ")
    } else {
      return ""
    } 
  }






  const insulation_length = () => {
    return props.item.insulation_configuration_decoration 
  } 

  if (props.item.gap === globalGap || globalGap === undefined) {
    return (
      <Aux>
        <th onClick={props.onToggle} className={props.color + " colLeft"} >{t(props.item.penetrations)}{colAnzahl(props.item.amount_min, props.item.amount_max)}</th>
        { (isSelected)?
          <Aux>
            <td onClick={props.onSubstract} className={props.color + " colLeft add-remove-handles"}  style={{width: "40px"}}><i className="material-icons icon-orange grow">remove_circle</i></td>
            <td className={props.color}  style={{width: "40px", fontSize: "20px"}}>{props.amount}x</td>
            <td onClick={props.onAdd}className={props.color + " colLeft add-remove-handles"}  style={{width: "40px"}}><i className="material-icons icon-orange grow">add_circle</i></td></Aux> : null
        }
        { (!isSelected)?
          <Aux>
            <td onClick={props.onToggle} className={props.color}  colSpan={3} style={{width: "120px"}}></td></Aux> : null
        }
        <td onClick={props.onToggle} className={props.color}  style={{width: "120px"}}>{props.colDiameter}</td>
        <td onClick={props.onToggle} className={props.color}  style={{width: "100px"}}>{fromToValue(props.item.thickness_min, props.item.thickness_max)}</td>

        {/* Ausgabe der Isolierung */}
        <td onClick={props.onToggle} className={props.color + " colLeft"} >{insulationNames()}</td>
        <td onClick={props.onToggle} className={props.color} style={{width: "100px"}}>{insulationThickness()}</td>
        <td onClick={props.onToggle} className={props.color} style={{width: "100px"}}>{insulationLength()}</td>

        <td onClick={props.onToggle} className={props.color + " colLeft"} >{ products_col(props.item) }</td>
        <td onClick={props.onToggle} className={props.color} style={{width: "90px"}}>{colFwk(props.item.classification, props.item.tube_configuration)}</td>
        <td onClick={props.onToggle} className={props.color + " colLeft"} style={{width: "100px"}}>{props.item.certification_reference}</td>
      </Aux>
      )
    } else {
      return (
        <Aux>
          <th className={props.color + " colLeft disabledLine"} >{t(props.item.penetrations)}{colAnzahl(props.item.amount_min, props.item.amount_max)}</th>
          <td className={props.color + " disabledLine"}  colSpan={3} style={{width: "120px"}}></td>
          <td className={props.color + " disabledLine"}  style={{width: "120px"}}>{fromToValue(props.item.diameter_min, props.item.diameter_max)}</td>
          <td className={props.color + " disabledLine"}  style={{width: "100px"}}>{fromToValue(props.item.thickness_min, props.item.thickness_max)}</td>
          <td className={props.color + " colLeft disabledLine"} >{insulationNames()}</td>
          <td className={props.color + " disabledLine"} style={{width: "100px"}}>{fromToValueUnendlich(props.item.insulation_strength_min, props.item.insulation_strength_max)}</td>
          <td className={props.color + " disabledLine"} style={{width: "100px"}}>{insulationLength()}</td>
          <td className={props.color + " colLeft disabledLine"} >{ products_col(props.item) }</td>
          <td className={props.color + " disabledLine"} style={{width: "90px"}}>{colFwk(props.item.classification, props.item.tube_configuration)}</td>
          <td className={props.color + " colLeft disabledLine"} style={{width: "100px"}}>{props.item.certification_reference}</td>
        </Aux>
        )
    }
};

export default productSystemTableRowRohr;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableRowRohr.js